import mongoose from 'mongoose';
import schema, { IRefundTransactionDocument } from '../schemas/refund-transaction';

const RefundTransaction = (mongoose.models.RefundTransaction ||
  mongoose.model('RefundTransaction', schema)) as mongoose.Model<IRefundTransactionDocument>;

export default RefundTransaction;
